// extracted by mini-css-extract-plugin
export default {"page-wrapper":"pr6Bt_VVWrYfnmelIfTx"};